/**
 * @generated SignedSource<<c0b8e94dd9a725fc0c0566c9ab6941ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateUserProfileInput = {
  avatar?: string | null;
  bio?: string | null;
  cover?: string | null;
  firstName?: string | null;
  id: string;
  lastName?: string | null;
  timezone?: string | null;
  webFormSubmission?: CreateWebFormSubmissionInput | null;
};
export type CreateWebFormSubmissionInput = {
  answers?: ReadonlyArray<WebFormAnswerInput> | null;
  contentUsageId?: string | null;
  webFormRevisionId: string;
};
export type WebFormAnswerInput = {
  body?: string | null;
  isSkipped?: boolean | null;
  selectedOptions?: ReadonlyArray<string> | null;
  webFormQuestionId: string;
};
export type ProfileSettingsProfileTabMutation$variables = {
  input: UpdateUserProfileInput;
  organizationId: string;
};
export type ProfileSettingsProfileTabMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly avatar: string;
      readonly " $fragmentSpreads": FragmentRefs<"ProfileSettingsProfileTabFragment">;
    } | null;
  };
};
export type ProfileSettingsProfileTabMutation = {
  response: ProfileSettingsProfileTabMutation$data;
  variables: ProfileSettingsProfileTabMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatar",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "organizationId",
    "variableName": "organizationId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webFormQuestionId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedOptions",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = {
  "kind": "Literal",
  "name": "status",
  "value": "visible"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v13 = {
  "kind": "Literal",
  "name": "isDefault",
  "value": false
},
v14 = {
  "kind": "Literal",
  "name": "isPrivate",
  "value": false
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileSettingsProfileTabMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserProfileResponse",
        "kind": "LinkedField",
        "name": "updateProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": (v3/*: any*/),
                "kind": "FragmentSpread",
                "name": "ProfileSettingsProfileTabFragment"
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfileSettingsProfileTabMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserProfileResponse",
        "kind": "LinkedField",
        "name": "updateProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "website",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cover",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "OrganizationMembership",
                "kind": "LinkedField",
                "name": "organizationMembership",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileValueNodeConnection",
                    "kind": "LinkedField",
                    "name": "profileValues",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileValueNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileValue",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "profileField",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormAnswer",
                                "kind": "LinkedField",
                                "name": "webFormAnswer",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "body",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebForm",
                        "kind": "LinkedField",
                        "name": "profileWebForm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WebFormRevision",
                            "kind": "LinkedField",
                            "name": "currentRevision",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "webFormId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormQuestionNodeConnection",
                                "kind": "LinkedField",
                                "name": "questions",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WebFormQuestionNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "WebFormQuestion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v9/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "richEditorBody",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "ordering",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isRequired",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WebFormQuestionOption",
                                            "kind": "LinkedField",
                                            "name": "options",
                                            "plural": true,
                                            "selections": [
                                              (v5/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "label",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "defaultFields",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "isDefault",
                            "value": true
                          },
                          (v10/*: any*/)
                        ],
                        "concreteType": "ProfileFieldNodeConnection",
                        "kind": "LinkedField",
                        "name": "profileFields",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileFieldNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "profileFields(isDefault:true,status:\"visible\")"
                      },
                      {
                        "alias": "customFields",
                        "args": [
                          (v13/*: any*/),
                          (v10/*: any*/)
                        ],
                        "concreteType": "ProfileFieldNodeConnection",
                        "kind": "LinkedField",
                        "name": "profileFields",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileFieldNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "profileFields(isDefault:false,status:\"visible\")"
                      },
                      (v5/*: any*/),
                      {
                        "alias": "publicCustomFields",
                        "args": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v10/*: any*/)
                        ],
                        "concreteType": "ProfileFieldNodeConnection",
                        "kind": "LinkedField",
                        "name": "profileFields",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileFieldNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WebFormQuestion",
                                    "kind": "LinkedField",
                                    "name": "webFormQuestion",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "profileFields(isDefault:false,isPrivate:false,status:\"visible\")"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "displayProfileValues",
                    "args": [
                      (v14/*: any*/)
                    ],
                    "concreteType": "ProfileValueNodeConnection",
                    "kind": "LinkedField",
                    "name": "profileValues",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileValueNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileValue",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "profileFieldId",
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "profileValues(isPrivate:false)"
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isTest",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "websiteUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "86e4dd80c87b8b5c78826ceab064f52f",
    "id": null,
    "metadata": {},
    "name": "ProfileSettingsProfileTabMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileSettingsProfileTabMutation(\n  $input: UpdateUserProfileInput!\n  $organizationId: ID!\n) {\n  response: updateProfile(input: $input) {\n    node {\n      avatar\n      ...ProfileSettingsProfileTabFragment_4xMPKw\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileNameWithTagFragment on User {\n  fullName\n}\n\nfragment ProfileSettingsCustomFieldsFragment_3fb12f on OrganizationMembership {\n  organization {\n    publicCustomFields: profileFields(status: visible, isPrivate: false, isDefault: false) {\n      edges {\n        node {\n          id\n          title\n          webFormQuestion {\n            type\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  displayProfileValues: profileValues(isPrivate: false) {\n    edges {\n      node {\n        id\n        profileFieldId\n        value\n      }\n    }\n  }\n}\n\nfragment ProfileSettingsCustomFormFieldsFragment on Organization {\n  customFields: profileFields(status: visible, isDefault: false) {\n    edges {\n      node {\n        id\n        title\n        isPrivate\n        webFormQuestionId\n      }\n    }\n  }\n  profileWebForm {\n    currentRevision {\n      questions {\n        edges {\n          node {\n            id\n            type\n            richEditorBody\n            options {\n              id\n              label\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ProfileSettingsProfileBannerFragment on User {\n  id\n  cover\n  ...ProfileAvatarFragment\n  ...ProfileNameWithTagFragment\n  isTest\n}\n\nfragment ProfileSettingsProfileFormFieldsFragment on Organization {\n  defaultFields: profileFields(status: visible, isDefault: true) {\n    edges {\n      node {\n        id\n        title\n        isPrivate\n      }\n    }\n  }\n}\n\nfragment ProfileSettingsProfileTabFragment_4xMPKw on User {\n  id\n  website\n  timezone\n  bio\n  lastName\n  firstName\n  avatar\n  cover\n  organizationMembership(organizationId: $organizationId) {\n    profileValues {\n      edges {\n        node {\n          id\n          profileField {\n            webFormQuestionId\n            id\n          }\n          value\n          selectedOptions\n          webFormAnswer {\n            body\n            selectedOptions\n            id\n          }\n        }\n      }\n    }\n    organization {\n      profileWebForm {\n        currentRevision {\n          id\n          webFormId\n          questions {\n            edges {\n              node {\n                id\n                type\n                richEditorBody\n                ordering\n                isRequired\n                options {\n                  id\n                  label\n                }\n              }\n            }\n          }\n        }\n        id\n      }\n      ...ProfileSettingsProfileFormFieldsFragment\n      ...ProfileSettingsCustomFormFieldsFragment\n      id\n    }\n    ...ProfileSettingsCustomFieldsFragment_3fb12f\n    id\n  }\n  ...ProfileSettingsProfileBannerFragment\n  ...ProfileSettingsUserSectionFragment_4xMPKw\n  ...ProfileNameWithTagFragment\n}\n\nfragment ProfileSettingsUserSectionFragment_4xMPKw on User {\n  id\n  bio\n  websiteUrl\n  timezone\n  organizationMembership(organizationId: $organizationId) {\n    id\n    organization {\n      defaultFields: profileFields(status: visible, isDefault: true) {\n        edges {\n          node {\n            id\n            title\n            isPrivate\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "904f8a3bfe69db462b47fdd241e75572";

export default node;
